export type MedicalConditionOption = {
  id: string;
  name: string;
  /** UI-only: free-text conditions are sent as the entered string, not this id */
  freeText?: true;
};

export const MEDICAL_CONDITION_OTHER_ID = 'other';

/** Predefined conditions: UI label → API id. */
export const MEDICAL_CONDITIONS_API_OPTIONS: readonly MedicalConditionOption[] = [
  { id: 'diabetes', name: 'Diabetes' },
  { id: 'prediabetes', name: 'Prediabetes' },
  { id: 'thyroid', name: 'Thyroid disorder' },
  { id: 'pcos', name: 'PCOS' },
  { id: 'insulin_resistance', name: 'Insulin resistance' },
  { id: 'High blood pressure', name: 'High BP' },
  { id: 'hyperlipidemia', name: 'High cholesterol' },
  { id: 'heart_disease', name: 'Heart disease' },
  { id: 'kidney_disease', name: 'Kidney disease' },
  { id: 'fatty_liver', name: 'Fatty liver' },
  { id: 'ibs', name: 'IBS' },
  { id: 'ibd', name: 'IBD' },
  { id: 'coeliac', name: 'Coeliac disease' },
  { id: 'eating_disorder', name: 'Eating disorder (current/past)' },
] as const;

/** Includes UI-only Other entry for labels; custom values are sent as free text. */
export const MEDICAL_CONDITIONS_OPTIONS: readonly MedicalConditionOption[] = [
  ...MEDICAL_CONDITIONS_API_OPTIONS,
  { id: 'other', name: 'Other', freeText: true },
];

/** Legacy API ids mapped to current ids when loading or saving client data. */
export const LEGACY_MEDICAL_CONDITION_IDS: Readonly<Record<string, string>> = {
  celiac: 'coeliac',
  liver_disease: 'fatty_liver',
  thyroid_disorders: 'thyroid',
  hypertension: 'High blood pressure',
};
